import styled from 'styled-components'

export const VersionPill = styled.span`
  font-size: 0.68rem;
  line-height: 1;
  font-weight: 600;
  border-radius: 999px;
  padding: 0.2rem 0.45rem;
  color: ${({ theme }) => theme.common.badge.text.blue};
  background: ${({ theme }) => theme.colors.gray[700]};
  border: 1px solid ${({ theme }) => theme.colors.gray[600]};
`

export const StagePill = styled.span<{ $color?: string }>`
  font-size: 0.68rem;
  line-height: 1;
  font-weight: 600;
  border-radius: 999px;
  padding: 0.2rem 0.45rem;
  color: ${({ $color }) => $color ?? '#999'};
  background: ${({ $color, theme }) =>
    $color ? `${$color}18` : theme.colors.gray[700]};
  border: 1px solid
    ${({ $color, theme }) => ($color ? `${$color}40` : theme.colors.gray[600])};
`
